{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://www.w3.org/ns/pub-schema/manifest/module/date.schema.json",
  "title": "Dates",
  "type": "string",
  "format": "date-time"
}
